import { useEffect } from "react";
import { useState } from "react";
import { useLocation } from "react-router-dom";

export type SUPPORTED_KEYS = "ref";

export function usePersistentQueryValue(key: SUPPORTED_KEYS) {
    const [value, setValue] = useState<string | null>(null);
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);

    useEffect(() => {
        const value = searchParams.get(key);
        if (value) {
            setValue(value);
            localStorage.setItem(key, value);
        } else {
            const storedValue = localStorage.getItem(key);
            if (storedValue) {
                setValue(storedValue);
            }
        }
    }, [searchParams, key, location.search]);

    return { value, setValue };
}
